export default {
  colors: {
    secondary: "#117ACA",
    primary: "#1B4584",
    gray: "#eee",
    darkgray: "#999",
    white: "#fff",
  },
};
